import type { JournalAccount } from "@/apis/gql/types";
import { BankAccountJournalAccountForm } from "@/components/shared/form/bank-account-journal-account-form";

type Props = {
  account: JournalAccount;
};

export const BankAccountDetails = ({ account }: Props) => {
  return (
    <BankAccountJournalAccountForm
      account={{
        journalAccountId: account.journalAccountId,
        number: account.number,
        name: account.name,
        entityId: account.entityId,
      }}
    />
  );
};
